/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import * as React from 'react';

function useLazyRef<T>(fn: () => T) {
	const ref = React.useRef<T | null>(null);

	if (ref.current === null) {
		ref.current = fn();
	}

	return ref as React.RefObject<T>;
}

export { useLazyRef };
